// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import AimOutlinedSvg from "@fishx/icons-svg/es/asn/AimOutlined";
import FishxIcon from '../components/FishxIcon';

var AimOutlined = function AimOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: AimOutlinedSvg
  }));
};

AimOutlined.displayName = 'AimOutlined';
export default React.forwardRef(AimOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/AimOutlined.js
// module id = 1950
// module chunks = 0